import { ContractPdfList } from './components/ContractPdfList';
import { Route, Routes } from 'react-router-dom';
import { hasAccessRight } from '../../utils/Functions';
import { AdminAclEnum } from '../../enum/AdminAclEnum';

export function ContractPdfRoutes() {
    return (
        <Routes>{hasAccessRight(AdminAclEnum.CONTRACT_PDFS) && <Route index element={<ContractPdfList />} />}</Routes>
    );
}
